/**
 * Maps B2B survey group API payloads to the app’s SurveyGroup shape.
 */
import type { SurveyGroupApiDetail } from 'src/types/survey-group-api.types';
import type { SurveyGroup } from 'src/types/survey-group.types';

export function apiSurveyGroupDetailToSurveyGroup(api: SurveyGroupApiDetail): SurveyGroup {
  const links = [...api.survey_links].sort((a, b) => a.display_order - b.display_order);
  const anchorExtSurveyId = links[0]?.survey.ext_survey_id ?? '';
  const memberExtSurveyIds = links.slice(1).map((l) => l.survey.ext_survey_id);
  return {
    id: api.id,
    name: api.name,
    createdAt: api.created_at,
    updatedAt: api.updated_at,
    anchorExtSurveyId,
    memberExtSurveyIds,
    mappings: [],
    shareId: api.share_id,
    questionLinkCount: typeof api.question_count === 'number' ? api.question_count : undefined,
    started: api.started,
    completed: api.completed,
  };
}
